import { Events, Statistics } from "app-interfaces";

import { EventType } from "../types/StaticTypes";

export default class EventsClass {
  /* Properties */
  private _lunch: Events.ILunch[] = [];
  private _blocked_days: Events.IBlockedDay[] = [];
  private _stats: Statistics.Stats[] = [];
  private _schedule: Events.ISchedule[] = [];
  private _agenda: Events.IAgenda[] = [];

  /* Getters & Setters */

  get lunch(): Events.ILunch[] {
    return this._lunch;
  }
  get blocked_days(): Events.IBlockedDay[] {
    return this._blocked_days;
  }
  get stats(): Statistics.Stats[] {
    return this._stats;
  }
  get schedule(): Events.ISchedule[] {
    return this._schedule;
  }
  get agenda(): Events.IAgenda[] {
    return this._agenda;
  }

  // Setters
  set lunch(events: Events.ILunch[]) {
    Object.assign(
      this._lunch,
      events.filter((el: Events.ILunch) => el.type === EventType.Lunch)
    );
  }
  set blocked_days(events: Events.IBlockedDay[]) {
    Object.assign(
      this._blocked_days,
      events.filter((el: Events.IBlockedDay) => el.type === EventType.BlockedDays)
    );
  }
  set stats(stats: Statistics.Stats[]) {
    Object.assign(this._stats, stats);
  }
  set schedule(schedule: Events.ISchedule[]) {
    Object.assign(this._schedule, schedule);
  }
  set agenda(agenda: Events.IAgenda[]) {
    Object.assign(this._agenda, agenda);
  }
}
